<rt-button
  #dropdownTrigger="rtOverlayOrigin"
  (mousedown)="placeholderSelectDropdownToggle($event)"
  [rtTooltip]="placeholderCategoryTranslationMap[category()].desc"
  [rtTooltipMaxWidth]="300"
  [pressed]="placeholderSelectDropdown.open"
  variant="tertiary"
  size="small"
  rt-overlay-origin
>
  <span class="text">{{ placeholderCategoryTranslationMap[category()].name }}</span>
  <rt-icon [name]="placeholderSelectDropdown.open ? 'arrow-drop-up' : 'arrow-drop-down'" />
</rt-button>

<ng-template
  #placeholderSelectDropdown="rtConnectedOverlay"
  [origin]="dropdownTrigger"
  [rtConnectedOverlayPosition]="['bottomleft']"
  (backdropClick)="placeholderSelectDropdown.open = false"
  rt-connected-overlay
  hasBackdrop
>
  @let selectedSubcategoryValue = selectedSubcategory();
  @if (!selectedSubcategoryValue) {
    <rt-dropdown class="dropdown">
      @for (placeholder of noSubcategoriesPlaceholders(); track placeholder.id) {
        <rt-dropdown-item
          [insertPlaceholder]="placeholder.id"
          [insertPlaceholderTarget]="activeTarget()!"
          [isSelected]="placeholder.id === active()?.id"
          (click)="select.emit(placeholder)"
          layout-vertical
        >
          <div layout layout-horizontal layout-space-between>
            <div layout layout-vertical>
              <rt-heading variant="heading">
                <span class="preserve-whitespace" margin-right-small-xx text-primary>[ </span>
                {{ withoutBrackets(placeholder.id) }}
                <span class="preserve-whitespace" margin-left-small-xx text-primary> ]</span>
              </rt-heading>
              <span
                [innerHTML]="
                  placeholder.interpolated ? placeholder.value : placeholder.data.description
                "
                class="description info-dropdown-text"
              >
              </span>
            </div>
          </div>
        </rt-dropdown-item>
      }
      @for (subcategory of subcategories(); track subcategory) {
        <rt-dropdown-item
          (mousedown)="setSubcategory(subcategory, $event)"
          [hasChevronRight]="true"
        >
          <div layout-vertical>
            <rt-heading variant="heading">
              {{ placeholderCategoryTranslationMap[subcategory].name }}
            </rt-heading>
            <span
              [innerHTML]="placeholderCategoryTranslationMap[subcategory].desc"
              class="description info-dropdown-text"
            ></span>
          </div>
        </rt-dropdown-item>
      }
    </rt-dropdown>
  } @else {
    <rt-placeholder-select-dropdown
      [placeholders]="placeholders()"
      [category]="selectedSubcategoryValue"
      [activeTarget]="activeTarget()"
      [active]="active()"
      [showHeader]="true"
      (back)="setSubcategory()"
      (select)="setSubcategory(); select.emit($event)"
    />
  }
</ng-template>
